import { useAIAssistant } from "@jugl-web/domain-resources/ai-assistant/providers";
import { Tooltip } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { NavbarButton } from "@web-src/modules/navigation/components/MainNavBar/components/NavbarButton";
import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { ReactComponent as AISmileIcon } from "./assets/ai-smile.svg";
import starsAnimation from "./assets/stars-animation.json";

export const AIAssistantButton: React.FC = () => {
  const { t } = useTranslations();
  const { handleOpenAIAssistantDialog } = useAIAssistant();
  const location = useLocation();

  const boardId = useMemo(() => {
    const segments = location.pathname.split("/").filter(Boolean);
    const boardIndex = segments.indexOf("board");

    if (boardIndex !== -1 && segments[boardIndex + 1]) {
      return segments[boardIndex + 1];
    }
    return undefined;
  }, [location.pathname]);

  const handleClick = () => {
    handleOpenAIAssistantDialog(true, boardId);
  };

  return (
    <Tooltip
      renderTrigger={({ props, ref }) => (
        <NavbarButton
          ref={ref}
          className="relative"
          onClick={handleClick}
          {...props}
        >
          <div className="pointer-events-none">
            <Lottie
              options={{ animationData: starsAnimation }}
              isClickToPauseDisabled
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) scale(3.1)",
              }}
            />
          </div>
          <div className="z-[1] flex items-center gap-1.5">
            <span>
              {t({
                id: "ai-assistant-button-component.ask-ai",
                defaultMessage: "Ask AI",
              })}
            </span>
            <AISmileIcon />
          </div>
        </NavbarButton>
      )}
    >
      {t({
        id: "ai-assistant-button-component.knowledge-assistant",
        defaultMessage: "Knowledge Assistant",
      })}
    </Tooltip>
  );
};
